import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import UserConsultationTab from "../Components/UserConsultationTab";
import { chat, consultantmage, file } from "../Constant/Index";

const UserPastConsultationsDetail = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="User Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<UserProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	 mb-3">
									<div class="edit-btn back">
										<Link to="/">
											<div class="nav-anchor">
												<i class="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<div className="d-flex align-items-center  justify-content-between w-100">
										<h5 class="main-heading level-6 ps-3 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
											My Consultations
										</h5>
										<UserConsultationTab />
									</div>
								</div>
								<div className="row">
									<div class="col-lg-12">
										<div class="content-qty extra-bg-14 radius-20 p-4 dark-color ">
											<div className="d-flex gap-3 align-items-center">
												<img
													src={consultantmage}
													className="img-fluid"
													alt=""
												/>
												<div>
													<h4 class="main-heading-font level-6 ">
														Dr. David Patel
													</h4>
													<h5 class="primary-medium-font level-8 extra-color-15">
														Physician
													</h5>
													<h4 class="primary-medium-font level-7 ">
														<span className="icon-point">
															<i class="fa-solid fa-location-dot"></i>
														</span>{" "}
														Golden Cardiology Center
													</h4>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="row  pt-5  border-bottom pb-4">
									<div class="col-lg-12">
										<div class="order-detail-content">
											<div class="row">
												<div class="col-lg-12">
													<div class="details-pharmacy">
														<h4 class="main-heading-font level-6 ">
															Working Time
														</h4>
														<h5 class="primary-medium-font level-8 extra-color-10">
															Monday-Friday, 08.00 AM - 12.00 PM
														</h5>
													</div>
												</div>
												<div class="col-lg-12 mt-3">
													<div class="details-pharmacy">
														<h4 class="main-heading-font level-6 ">
															Qualification
														</h4>
														<h5 class="primary-medium-font level-8 extra-color-10">
															MBBS
														</h5>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="row border-top pt-4  pb-4">
									<div class="col-lg-12">
										<div class="order-detail-content">
											<div class="row">
												<div class="col-lg-12">
													<div class="details-pharmacy">
														<h4 class="main-heading-font level-6 ">Symptoms</h4>
														<h5 class="primary-medium-font level-8 extra-color-10">
															Allergy
														</h5>
													</div>
												</div>
												<div class="col-lg-12 mt-3">
													<div class="details-pharmacy">
														<h4 class="main-heading-font level-6 ">Details</h4>
														<h5 class="primary-medium-font level-8 extra-color-10">
															Nullam iaculis metus nec mauris egestas convallis.
															Praesent sit amet urna libero. Aliquam efficitur
															gravida dui, vel accumsan massa vehicula ut.
															Aliquam felis.
														</h5>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-2">
									<div className="col-lg-12">
										<div className="d-flex align-items-center gap-3">
											<Link
												class="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
												href="/current-consultations-detail"
												to="/user-prescription"
											>
												<span class="bg-wrapper w-100">
													{" "}
													<img
														src={file}
														className="img-fluid pe-3"
														alt=""
													/>{" "}
													View Prescription{" "}
												</span>
											</Link>
											<Link
												class="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
												href="/current-consultations-detail"
												to="/user-notes"
											>
												<span class="bg-wrapper w-100">
													<img src={file} className="img-fluid pe-3" alt="" />
													View Notes
												</span>
											</Link>
										</div>
									</div>
								</div>
								<div class="row mt-4">
									<div class="col-lg-12">
										<Link
											class="color-view-details detail-physician-btn calender-bg  w-100 d-flex align-items-center justify-content-center dark-color"
											to="/user-chat"
										>
											<span>
												<img src={chat} alt="" className="img-fluid" />
											</span>
											View Chat
										</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default UserPastConsultationsDetail;
